export const inputCls =
  "w-full bg-[#0A0A0A] border border-[#28282D] rounded-lg px-3 py-2.5 text-sm text-white placeholder:text-zinc-600 focus:border-yellow-400 outline-none transition-colors";

export const btnPrimary =
  "bg-yellow-400 text-black font-bold text-sm px-5 py-2.5 rounded-full hover:bg-yellow-300 transition-colors disabled:opacity-50";

export const btnGhost =
  "border border-[#28282D] text-zinc-300 text-sm px-4 py-2 rounded-full hover:border-yellow-400/50 transition-colors";

export const cardCls = "bg-[#121214] border border-[#28282D] rounded-xl p-5";
